"use client";

import React from "react";

//Types
import { FooterCopyProps } from "@/types";

//Styles
import * as S from "./styles";

const CopyFooter: React.FC<FooterCopyProps> = ({
  className,
  children,
  dict,
}) => {
  return (
    <S.FooterCopy className={className}>
      <S.TextCopy>
        {children || dict["© 2025 Striva. All rights reserved."]}
      </S.TextCopy>
    </S.FooterCopy>
  );
};

export default CopyFooter;
